import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="user-stream-item__header info">
  <a
    href={{this.userUrl}}
    data-user-card={{this.post.user.username}}
    class="avatar-link"
  >
    {{avatar
      this.post.user
      imageSize="large"
      extraClasses="actor"
      ignoreTitle="true"
    }}
  </a>

  <div class="user-stream-item__details">
    <div class="stream-topic-title">
      <span class="title">
        <a href={{this.postUrl}} aria-label={{this.titleAriaLabel}}>
          {{html-safe this.post.topic.fancyTitle}}
        </a>
      </span>
    </div>
    <div class="group-post-category">{{category-link this.post.category}}</div>
    {{#if this.post.user}}
      <div class="group-member-info names">
        <span class="name">{{this.name}}</span>
        {{#if this.post.user.title}}<span
            class="user-title"
          >{{this.post.user.title}}</span>{{/if}}
        <PluginOutlet
          @name="group-post-additional-member-info"
          @outletArgs={{hash user=this.post.user}}
        />
      </div>
    {{/if}}
  </div>

  <ExpandPost @item={{this.post}} />
  <span class="time">{{format-date this.post.created_at leaveAgo="true"}}</span>
</div>

<div class="excerpt">
  {{#if this.post.expandedExcerpt}}
    {{html-safe this.post.expandedExcerpt}}
  {{else}}
    {{html-safe this.post.excerpt}}
  {{/if}}
</div>
*/
{
  "id": "jtc9DTuJ",
  "block": "[[[10,0],[14,0,\"user-stream-item__header info\"],[12],[1,\"\\n  \"],[10,3],[15,6,[30,0,[\"userUrl\"]]],[15,\"data-user-card\",[30,0,[\"post\",\"user\",\"username\"]]],[14,0,\"avatar-link\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[[30,0,[\"post\",\"user\"]]],[[\"imageSize\",\"extraClasses\",\"ignoreTitle\"],[\"large\",\"actor\",\"true\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"user-stream-item__details\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"stream-topic-title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"title\"],[12],[1,\"\\n        \"],[10,3],[15,6,[30,0,[\"postUrl\"]]],[15,\"aria-label\",[30,0,[\"titleAriaLabel\"]]],[12],[1,\"\\n          \"],[1,[28,[35,1],[[30,0,[\"post\",\"topic\",\"fancyTitle\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"group-post-category\"],[12],[1,[28,[35,2],[[30,0,[\"post\",\"category\"]]],null]],[13],[1,\"\\n\"],[41,[30,0,[\"post\",\"user\"]],[[[1,\"      \"],[10,0],[14,0,\"group-member-info names\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"name\"],[12],[1,[30,0,[\"name\"]]],[13],[1,\"\\n        \"],[41,[30,0,[\"post\",\"user\",\"title\"]],[[[10,1],[14,0,\"user-title\"],[12],[1,[30,0,[\"post\",\"user\",\"title\"]]],[13]],[]],null],[1,\"\\n        \"],[8,[39,4],null,[[\"@name\",\"@outletArgs\"],[\"group-post-additional-member-info\",[28,[37,5],null,[[\"user\"],[[30,0,[\"post\",\"user\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[8,[39,6],null,[[\"@item\"],[[30,0,[\"post\"]]]],null],[1,\"\\n  \"],[10,1],[14,0,\"time\"],[12],[1,[28,[35,7],[[30,0,[\"post\",\"created_at\"]]],[[\"leaveAgo\"],[\"true\"]]]],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"excerpt\"],[12],[1,\"\\n\"],[41,[30,0,[\"post\",\"expandedExcerpt\"]],[[[1,\"    \"],[1,[28,[35,1],[[30,0,[\"post\",\"expandedExcerpt\"]]],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,1],[[30,0,[\"post\",\"excerpt\"]]],null]],[1,\"\\n\"]],[]]],[13]],[],false,[\"avatar\",\"html-safe\",\"category-link\",\"if\",\"plugin-outlet\",\"hash\",\"expand-post\",\"format-date\"]]",
  "moduleName": "discourse/components/group-post.hbs",
  "isStrictMode": false
});